import type { TOC } from '@ember/component/template-only';

import ReportsEditorPagelessComponent from 'webapp/components/reports/editor-pageless';
import ReportsEditorSlidesComponent from 'webapp/components/reports/editor-slides';
import type ReportsEditorReportController from 'webapp/controllers/reports/editor/report';

interface Args {
	controller: ReportsEditorReportController;
}

const ReportsEditorReportRouteTemplate: TOC<Args> = <template>
	{{#if @controller.isPagelessView}}
		<ReportsEditorPagelessComponent
			@model={{@controller.report}}
			@changeViewMode={{@controller.changeViewMode}}
			@closeEditor={{@controller.closeEditor}}
		/>
	{{else}}
		<ReportsEditorSlidesComponent
			@model={{@controller.report}}
			@selectedSlideId={{@controller.selectedSlideId}}
			@onSlideChange={{@controller.changeSlide}}
			@changeViewMode={{@controller.changeViewMode}}
			@closeEditor={{@controller.closeEditor}}
		/>
	{{/if}}
</template>;

export default ReportsEditorReportRouteTemplate;
